import * as React from 'react'
import { styled } from 'next-yak'

import * as copy from '../../styles/copy'
import * as heading from '../../styles/heading'
import * as notification from '../../styles/notification'

import { Base, type BaseProps } from './Base'

export type CalloutProps = BaseProps & {
  title?: string
  wrapWithCopy?: boolean
}

function CalloutComponent({
  children,
  className,
  customIcon,
  customIconSize,
  title,
  type,
  wrapWithCopy = true,
}: CalloutProps): React.ReactElement<CalloutProps> {
  return (
    <Base className={className} customIcon={customIcon} customIconSize={customIconSize} type={type} component="callout">
      <notification.CalloutContentWrapper>
        {title && <heading.XXXS>{title}</heading.XXXS>}
        {wrapWithCopy ? <copy.S.regular>{children}</copy.S.regular> : children}
      </notification.CalloutContentWrapper>
    </Base>
  )
}

export const Callout = styled(CalloutComponent)<CalloutProps>``
Callout.displayName = 'Callout'
